<div class="library-group-list">
  @for (group of groups; track group) {
    <app-library-group [group]="group"></app-library-group>
  } @empty {
    <div class="library-group-list-empty">
      <img [src]="'/svg/empty-creative.svg' | assetVersion" alt=""/>
      @if (loadError) {
        <p class="empty-title">Creatives could not be loaded</p>
        <p class="empty-subtitle">The creative data request failed.</p>
      } @else if (exhausted) {
        <p class="empty-title">The creatives in this chat are no longer available</p>
        <p class="empty-subtitle">They were removed, or they belong to brands outside this account.</p>
      } @else {
        <p class="empty-title">No creatives yet</p>
        <p class="empty-subtitle">Creatives referenced in this chat will show up here.</p>
      }
    </div>
  }
</div>
